/*
 * @Author: your name
 * @Date: 2021-12-06 09:12:00
 * @LastEditTime: 2021-12-06 11:44:54
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\finished-project\final-accounts\finalAccounts.routing.ts
 */

export const FinalAccountsRouting = [
  {
    path: "/finished-project/final-accounts/list",
    name: "final-accounts-list",
    meta: { title: "审定利润" },
    component: () => import("@/views/finished-project/final-accounts/list/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/final-accounts/create",
    name: "final-accounts-create",
    meta: { title: "新增审定登记",comName:"finishedProjectFinalAccountsFormCreate" },
    component: () => import("@/views/finished-project/final-accounts/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/final-accounts/edit/:id",
    name: "final-accounts-edit",
    meta: { title: "编辑审定登记",comName:"finishedProjectFinalAccountsFormCreate" },
    component: () => import("@/views/finished-project/final-accounts/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/final-accounts/detail/:id",
    name: "final-accounts-detail",
    meta: { title: "审定详情" },
    component: () => import("@/views/finished-project/final-accounts/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/finished-project/final-accounts/flowPrint/:id",
    name: "finished-project-final-accounts-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "finished-project-final-accounts" */ "@/views/finished-project/final-accounts/flow-print/index.vue"
      ),
  }
];
